@if (isLoading) {
  <div class="loader-position-standart-black loader-background"></div>
}
<div class="card mt-4 p-0 user-management">
  <div class="card-body p-0">
    <!-- Header page -->
    <div #stickyToolbar class="sticky-toolbar row align-items-center pl-12px">
      <div class="toolbar-search pl-0">
        <div class="row h-100">
          <div class="col-md-12 h-100">
            <div class="d-flex align-items-center h-100">
              <div class="input-group flex-grow-1">
                <span class="input-group-append">
                  <div class="input-group-text"><i class="fa fa-search"></i></div>
                </span>
                <input
                  class="form-control h-100 m-0 pl-0"
                  type="text"
                  [(ngModel)]="searchField"
                  (ngModelChange)="search.next($event)"
                  [placeholder]="tr('tapToSearch')"
                  />
              </div>
              <!-- Reset Filters Button - Only show when filters are active -->
              @if (hasActiveFilters()) {
                <span
                  class="filter-remove-text align-items-center d-flex ml-2"
                  (click)="clearFilters()"
                  >
                  <i class="icon-filter-off black-circle mr-2"></i
                    ><span class="filter-reset-text">{{ tr('reset') }}</span>
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto ms-auto text-end">
          <button (click)="createUser(templateCreateUser)" type="button" class="btn btn-primary">
            <i class="icon-plus icon-btn-offset"></i>
            <span class="btn-text">{{ tr('addNewUser') }}</span>
          </button>
        </div>
      </div>

      <!-- AG Grid Table -->
      <app-ag-grid-table
        class="ag-grid-wrapper"
        [tableName]="tableName"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [lockedColumns]="lockedColumns"
        [localeText]="localeText"
        [rowData]="displayedUsers"
        [rowHeight]="minRowHeight"
        [getContextMenuItems]="getContextMenuItems"
        [suppressRowClickSelection]="true"
        (gridReady)="onGridReady($event)"
        (filterChanged)="onFilterChanged()"
        (sortChanged)="onSortChanged()"
        (rowClicked)="onRowItemClicked($event)">
      </app-ag-grid-table>

      <!-- Empty state -->
      @if (!displayedUsers.length && !isLoading) {
        <div class="text-center mt-3 mb-3 empty-state-message">{{ tr('noUsersFound') }}</div>
      }

      <!-- Sentinel element for infinite scroll (page scrolls inside .app-content, not window) -->
      <div #scrollSentinel></div>

      <!-- Load more indicator -->
      @if (loadingMore) {
        <div class="loader-position-standart-black loader-background"></div>
      }

    </div>
  </div>

  <ng-template #templateDeleteUser>
    <div class="modal-body">
      <i class="icon-close" (click)="onCancel()"></i>
      <div class="delete-header">
        <span class="icon-delete"></span>
        <div>
          <h4 class="m-0">{{ tr('deleteUser') }}</h4>
          <span class="confirm-description"> {{ tr('confirmDeleteUser') }} </span>
        </div>
      </div>
      <div class="mt-4 col-12 row">
        <div class="col-6">
          <button type="button" class="btn btn-secondary w-100 text-underline" (click)="onCancel()"> <span class="btn-text">{{ tr('no') }}</span></button>
        </div>
        <div class="col-6">
          <button class="btn btn-primary w-100" (click)="onConfirm()"> <span class="btn-text">{{ tr('yes') }}</span></button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #editUserTemplate>
    <div class="modal-body modal-padded">
      <i class="icon-close" (click)="onCancel()"></i>
      <h5 class="mb-0">{{ tr('editUser') }}</h5>
      <form [formGroup]="modalForm" class="mt-4 d-flex flex-column">
        <label class="form-label w-100 pb-3 mb-1">
          {{ tr('firstName') }}<i class="required">*</i>
          <div class="input-icon-wrapper">
            <input type="text" class="form-control secondary-bg" formControlName="firstName" [placeholder]="tr('enterFirstName')" maxlength="100"
              [ngClass]="modalForm.get('firstName')?.touched && modalForm.get('firstName')?.value?.trim().length === 0 ? 'invalid' : ''"/>
            @if (modalForm.get('firstName')?.touched && modalForm.get('firstName')?.value?.trim().length === 0) {
              <i class="icon-cancel"></i>
            }
          </div>
          @if (modalForm.get('firstName')?.touched && modalForm.get('firstName')?.value?.trim().length === 0) {
            <span class="field-error mb-3">{{ tr('firstNameRequired') }}</span>
          }
        </label>
        <label class="form-label w-100 pb-3 mb-1">
          {{ tr('lastName') }}<i class="required">*</i>
          <div class="input-icon-wrapper">
            <input type="text" class="form-control secondary-bg" formControlName="lastName" [placeholder]="tr('enterLastName')" maxlength="100"
              [ngClass]="modalForm.get('lastName')?.touched && modalForm.get('lastName')?.value?.trim().length === 0 ? 'invalid' : ''"/>
            @if (modalForm.get('lastName')?.touched && modalForm.get('lastName')?.value?.trim().length === 0) {
              <i class="icon-cancel"></i>
            }
          </div>
          @if (modalForm.get('lastName')?.touched && modalForm.get('lastName')?.value?.trim().length === 0) {
            <span class="field-error mb-3">{{ tr('lastNameRequired') }}</span>
          }
        </label>
        <label class="form-label w-100 pb-3 mb-1">
          {{ tr('emailLabel') }}<i class="required">*</i>
          <input type="text" class="form-control secondary-bg disabled-form" formControlName="email" placeholder=""/>
        </label>
        <label class="form-label w-100 pb-3 mb-1">
          {{ tr('tenant') }}
          <app-chip-select
            formControlName="tenantIds"
            [options]="tenantOptions"
            placeholder="Select tenants"
            addMoreText="Add more...">
          </app-chip-select>
        </label>
      </form>
      <div class="mt-2 col-12 row pr-0">
        <div class="col-6 pl-0 pr-1">
          <button type="button" class="btn btn-link btn-secondary w-100 text-decoration-none" (click)="onCancel()"> <span class="btn-text">{{ tr('cancel') }}</span></button>
        </div>
        <div class="col-6 pr-0 pl-1">
          <button class="btn btn-primary w-100" [disabled]="modalForm.invalid" (click)="onConfirm()"> <span class="btn-text">{{ tr('save') }}</span></button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #templateResetPassword>
    <div class="modal-body modal-padded">
      <h5>{{ tr('resetPasswordEmail') }}</h5>
      <div class="float-end w-100 mt-4">
        <button type="button" class="btn btn-link btn-secondary btn-half" (click)="onCancel()"> <span class="btn-text">{{ tr('no') }}</span></button>
        <button type="button" class="btn btn-primary btn-half-spaced" (click)="onConfirm()">
          <span class="btn-text">{{ tr('yes') }}</span>
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #templateCreateUser>
    <div class="modal-body modal-padded">
      <i class="icon-close" (click)="cancelCreate()"></i>
      <h5 class="mb-0">{{ tr('addUser') }}</h5>
      <form [formGroup]="createUserForm" class="mt-4 d-flex flex-column">
        <label class="form-label w-100 pb-3 mb-1">
          {{ tr('firstName') }}<i class="required">*</i>
          <div class="input-icon-wrapper">
            <input type="text" class="form-control secondary-bg" formControlName="firstName" [placeholder]="tr('enterFirstName')" maxlength="100"
              [ngClass]="cf['firstName'].touched && cf['firstName'].value?.trim().length === 0 ? 'invalid' : ''"/>
            @if (cf['firstName'].touched && cf['firstName'].value?.trim().length === 0) {
              <i class="icon-cancel"></i>
            }
          </div>
          @if (cf['firstName'].touched && cf['firstName'].value?.trim().length === 0) {
            <span class="field-error mb-3">{{ tr('firstNameRequired') }}</span>
          }
        </label>
        <label class="form-label w-100 pb-3 mb-1">
          {{ tr('lastName') }}<i class="required">*</i>
          <div class="input-icon-wrapper">
            <input type="text" class="form-control secondary-bg" formControlName="lastName" [placeholder]="tr('enterLastName')" maxlength="100"
              [ngClass]="cf['lastName'].touched && cf['lastName'].value?.trim().length === 0 ? 'invalid' : ''"/>
            @if (cf['lastName'].touched && cf['lastName'].value?.trim().length === 0) {
              <i class="icon-cancel"></i>
            }
          </div>
          @if (cf['lastName'].touched && cf['lastName'].value?.trim().length === 0) {
            <span class="field-error mb-3">{{ tr('lastNameRequired') }}</span>
          }
        </label>
        <label class="form-label w-100 pb-3 mb-1">
          {{ tr('emailLabel') }}<i class="required">*</i>
          <div class="input-icon-wrapper">
            <input type="text" class="form-control secondary-bg" formControlName="email" [placeholder]="tr('enterEmail')" maxlength="100"
              [ngClass]="cf['email'].touched && (cf['email'].hasError('email') || isEmailExist) ? 'invalid' : ''"/>
            @if (cf['email'].touched && (cf['email'].hasError('email') || isEmailExist)) {
              <i class="icon-cancel"></i>
            }
          </div>
          @if (cf['email'].touched && cf['email'].hasError('email')) {
            <span class="field-error mb-3">{{ tr('invalidEmail') }}</span>
          }
          @if (cf['email'].touched && isEmailExist) {
            <span class="field-error mb-3">{{ tr('emailInUse') }}</span>
          }
        </label>
        <label class="form-label w-100 pb-3 mb-1">
          {{ tr('tenant') }}<i class="required">*</i>
          <app-simple-searchable-dropdown
            formControlName="tenantName"
            [options]="tenantOptions"
            placeholder="Select Tenant"
            [ngClass]="cf['tenantName'].touched && !cf['tenantName'].value ? 'invalid' : ''"
          ></app-simple-searchable-dropdown>
          @if (cf['tenantName'].touched && !cf['tenantName'].value) {
            <span class="field-error mb-3">{{ tr('tenantRequired') }}</span>
          }
        </label>
      </form>
      <div class="row mt-2">
        <div class="col-6">
          <button type="button" class="btn btn-link btn-secondary w-100" (click)="cancelCreate()" [disabled]="isCreatingUser"> <span class="btn-text">{{ tr('cancel') }}</span></button>
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-primary w-100" [disabled]="createUserForm.invalid || isEmailExist || isEmailChecking || isCreatingUser" (click)="saveCreateUser()"> <span class="btn-text">{{ tr('save') }}</span></button>
        </div>
      </div>
    </div>
  </ng-template>
